import { navigateTo } from 'nuxt/app'
import { useUsersStore } from '~/stores/users'

export default defineNuxtRouteMiddleware((to) => {
  const userStore = useUsersStore()

  if (import.meta.client && to.name === 'account-ontbrekende-gegevens') {
    if (
      !!userStore.specificUser?.foodie &&
      !userStore.specificUser.foodie.isMissingDetails
    ) {
      return navigateTo({ name: 'account' })
    } else if (
      !!userStore.specificUser?.cook &&
      !userStore.specificUser.cook.isMissingDetails
    ) {
      return navigateTo({ name: 'account' })
    }
  }
})
